var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.50003 10C3.50003 6.22879 3.50003 4.34317 4.74483 3.1716C5.98962 2.00002 7.99309 2.00002 12 2.00002H12.7728C16.034 2.00002 17.6646 2.00002 18.797 2.79786C19.1214 3.02645 19.4095 3.29755 19.6523 3.60291C20.5 4.6687 20.5 6.20338 20.5 9.27275V11.8182C20.5 14.7814 20.5 16.263 20.0311 17.4463C19.2772 19.3486 17.6829 20.8491 15.6617 21.5587C14.4044 22 12.8302 22 9.68185 22C7.88278 22 6.98325 22 6.26481 21.7478C5.10982 21.3424 4.19878 20.4849 3.76799 19.3979C3.50003 18.7217 3.50003 17.8751 3.50003 16.1818V10Z",
  stroke: "#333333",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 12C20.5 13.841 19.0076 15.3334 17.1667 15.3334C16.5009 15.3334 15.716 15.2167 15.0687 15.3901C14.4935 15.5443 14.0443 15.9935 13.8902 16.5687C13.7167 17.216 13.8334 18.0009 13.8334 18.6667C13.8334 20.5076 12.341 22 10.5 22",
  stroke: "#333333",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00003 7.00002H15",
  stroke: "#333333",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00003 11H11",
  stroke: "#333333",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgReportMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMarket);
export default __webpack_public_path__ + "static/media/reportMarket.154de60c.svg";
export { ForwardRef as ReactComponent };